import React, { useRef } from 'react';

const CSS = require('./SelectMenuItem.module.scss');

interface SelectMenuItemProps {
  selectedItem: string;
  options: { value: string; label: string }[];
  onSelect: (value: string) => void;
  onClick?: () => void;
  label: string;
}

function SelectMenuItem({
  selectedItem,
  options,
  onSelect,
  onClick,
  label,
}: SelectMenuItemProps) {
  const selectRef = useRef(null);

  const onChange = (event) => {
    onSelect(event.target.value);
  };

  return (
    <div className={CSS.SelectMenuItem}>
      <span className={CSS.Label}>{label}</span>
      <select
        className={CSS.Select}
        value={selectedItem}
        onChange={onChange}
        onClick={onClick}
        ref={selectRef}
      >
        {options.map(({ value, label }) => {
          return (
            <option key={value} value={value}>
              {label}
            </option>
          );
        })}
      </select>
    </div>
  );
}

export default SelectMenuItem;
